export default function ContentThird({verticalTabsState}) {
  return (
    <div
      className={`content-3 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 3
          ? "max-h-[1000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h3 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Beautiful Accounting Software</strong>
      </h3>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Do more, in less time.
      </p>

      <h3 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Invoicing</strong>
      </h3>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Create sharp and professional invoices, manage recurring billings, and
        easily track payments
      </p>

      <h3 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Manage Bills & Expenses</strong>
      </h3>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Control supplier invoices and get a clear forecast of your future bills
        to pay.
      </p>

      <h3 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Get Paid Faster</strong>
      </h3>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Electronic invoicing and automated follow-ups.
      </p>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Create and send professional <strong>invoices</strong>
      </p>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Send reminders to your debtors in just a few clicks. Simply set-up and
        automate follow-ups <strong>to get paid more quickly</strong>.
      </p>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        <strong>Automatically create invoices</strong> from sales orders,
        delivery orders or base them on time and material.
      </p>

      <h3 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Beautiful Dynamic Statements</strong>
      </h3>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Your reports, the way you like them.
      </p>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Easily create your <strong>earnings report, </strong>
        <strong>balance sheet, </strong>
        or <strong>cash flow statements</strong>.
      </p>

      <p className="mb-[20px] text-[16px] leading-[28px]">
        Quickly filter, zoom, annotate and compare any data.
      </p>
    </div>
  );
}
